import { render, staticRenderFns } from "./view-information.vue?vue&type=template&id=7d378f32&scoped=true"
import script from "./view-information.vue?vue&type=script&lang=js"
export * from "./view-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d378f32",
  null
  
)

export default component.exports